import { useEffect, useState } from 'react';
import { ExternalLink, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PartnerRedirect = () => {
  const prodUrl = 'partner.zenstudios.in';
  const previewUrl = `/api/partner-portal`;
  const [popupBlocked, setPopupBlocked] = useState(false);

  useEffect(() => {
    // Try opening in a new window; fall back to same-window redirect if blocked
    const newWindow = window.open(previewUrl, '_blank');
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      setPopupBlocked(true);
    }
  }, [previewUrl]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4" data-testid="partner-redirect-page">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-indigo-500/20">
          <Users className="w-10 h-10 text-white" />
        </div>

        <h1 className="text-3xl font-bold text-white mb-2">
          <span className="text-white">Zen</span>
          <span className="text-indigo-400">Studios</span>
        </h1>

        <h2 className="text-xl text-slate-300 mb-4">Partner Portal</h2>

        <p className="text-slate-400 mb-8">
          {popupBlocked
            ? 'Your browser blocked the popup. Click the button below to open the Partner Portal.'
            : 'Opening Partner Portal in a new tab...'}
        </p>

        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-6">
          <p className="text-slate-300 text-sm mb-2">Production URL:</p>
          <p className="text-indigo-400 font-mono text-lg mb-4">{prodUrl}</p>
          <p className="text-slate-400 text-xs">Preview environment available below</p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700"
            onClick={() => {
              const w = window.open(previewUrl, '_blank');
              if (!w) window.location.href = previewUrl;
            }}
            data-testid="open-partner-portal-btn"
          >
            Open Partner Portal <ExternalLink className="w-4 h-4 ml-2" />
          </Button>
        </div>

        <p className="text-slate-500 text-sm mt-6">
          For Agents, Developers &amp; Service Vendors.
        </p>
      </div>
    </div>
  );
};

export default PartnerRedirect;
